module.exports = __webpack_public_path__ + "static/media/congratulate_important.aa8989e4.svg";